import OrdersRoute from '@src/routes/OrderCenter/Orders'
import requireAuthentication from '@utils/requireAuthenticationGIP'
import { NextPage } from 'next'
import Head from 'next/head'
import React from 'react'
import { useIntl } from 'react-intl'
import ErrorPage from '@src/pages/_error'

const Orders: NextPage<{ errorStatus?: number }> = ({ errorStatus }) => {
  const intl = useIntl()

  if (errorStatus) {
    return <ErrorPage statusCode={errorStatus} />
  }

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'ORDER_CENTER',
            defaultMessage: 'Order Center',
          })}
        </title>
      </Head>
      <OrdersRoute />
    </>
  )
}

Orders.getInitialProps = requireAuthentication()

export default Orders
